/**
 * Volume mixin
 *
 * Добавляет логику для изменения громкости
 *
 */

import CONSTANTS from '@/helpers/constants';

export default {
  staticData: () => ({
    volume: 0,
    volumeStep: 20,
  }),
  created() {
    this.getVolume();
    this.initVolumeActions();
  },
  methods: {
    setVolume(volume) {
      this.volume = Number(volume);
      this.$robot.settingsService.setVolume(this.volume);
    },
    setVolumeUp() {
      const up = this.volume + this.volumeStep;
      const volume = up <= 100 ? up : 100;
      this.setVolume(volume);
    },
    setVolumeDown() {
      const down = this.volume - this.volumeStep;
      const volume = down >= 0 ? down : 0;
      this.setVolume(volume);
    },
    async getVolume() {
      try {
        this.volume = await this.$robot.settingsService.getVolume();
      } catch (e) {
        console.error('settingsService.getVolume error: ', e);
      }
    },
    initVolumeActions() {
      const rootActions = [
        [CONSTANTS.ACTION_VOLUME_UP, this.setVolumeUp],
        [CONSTANTS.ACTION_VOLUME_DOWN, this.setVolumeDown],
      ];
      rootActions.forEach((action) => this.$root.$on(...action));
      this.$once('hook:beforeDestroy', () => {
        rootActions.forEach((action) => this.$root.$off(...action));
      });
    },
  },
};
